import React, {useEffect} from "react";
import FormEventDetails from "./FormEventDetails";
import FormTimesheetSection from "./Timesheets/FormTimesheetSection";
import MedicationAdministeredSection from "./MedicineAdministered/MedicationAdministeredSection";
import FormDetails from "./FormDetails";
import SafeguardingForm from "./SafeguardingForm";
import {EndOfShiftReportPayload} from "../../../../../../../store/dutyManagerReport/actions/DutyManagerReportActionTypes";
import {useDispatch} from "react-redux";
import {fetchDrugBatchesWithinPack} from "../../../../../../../store/drugBatch/actions/DrugBatchActions";
import VehicleSection from "../DutyManagerForm/Vehicle/VehicleSection";

const EndOfShiftReportInsert = (props: EndOfShiftReportPayload) => {
    const dispatch = useDispatch();

    // Preload the drug batches
    useEffect(() => {
        const foundPacks = new Set<number>();
        for (const item of props.medicineAdministered) {
            if (!item.packId || foundPacks.has(item.packId)) continue;
            foundPacks.add(item.packId);
            if (item.packId) dispatch(fetchDrugBatchesWithinPack(item.packId));
        }
    }, []);

    return (
        <React.Fragment>
            <FormEventDetails />
            <FormTimesheetSection />
            <VehicleSection {...props} />
            <MedicationAdministeredSection {...props} />
            <SafeguardingForm {...props} />
            <FormDetails {...props} />
        </React.Fragment>
    );
};

export default EndOfShiftReportInsert;
